import {useEffect, useState} from 'react';
import {Card, Checkbox, Col, Collapse, Descriptions, message, Row, Tag} from 'antd';
import {CustomerDto} from "../../../dto/CustomerDto";
import {AddressDto} from "../../../dto/AddressDto";
import {BankDetailDto} from "../../../dto/BankDetailDto";
import {
    COMMON_DROPDOWN,
    IDENTIFICATION_SOURCE,
    NOT_AVAILABLE,
    PARAMETER_LIST,
    RADIO_BUTTON_VALUES
} from "../../../util/Constants";
import {InputDropdownParameterDto} from "../../../dto/InputDropdownParameterDto";
import {PageStep} from "../../../enums/PageStep";
import customerService from "../../../service/customerService";
import {DropdownListDto} from "../../../dto/DropdownListDto";
import {MSG_FAILED_TO_FETCH_COMMON_DROPDOWN_TYPES_ERROR} from "../../../util/Messages";
import ErrorHandler from "../../../util/ErrorHandler";
import {WorkbasketTableDto} from "../../../dto/admin/WorkbasketTableDto";
import './style.scss';
import {
    reject_user,
    remark,
    step_1_inactive_img,
    step_2_inactive_img,
    step_3_inactive_img,
    step_4_inactive_img,
    step_5_inactive_img,
    step_6_inactive_img,
    step_7_inactive_img
} from '../../../../AppImageConst';
import CommonFunction from "../../../util/CommonFunction";

type ExpandIconPosition = 'start' | 'end';

interface CollapseDataProps {
    dataDto?: CustomerDto,
}

const OTHER = "Other";

const LeftSideDetailsCollapse = (props: CollapseDataProps) => {
    const [expandIconPosition] = useState<ExpandIconPosition>('start');
    const [customerDto, setCustomerDto] = useState<CustomerDto>();
    const [addressList, setAddressList] = useState<AddressDto[]>();

    const [bankList, setBankList] = useState<BankDetailDto[]>();
    const [userDetailsPageAgreements, setUserDetailsPageAgreements] = useState<DropdownListDto[]>([]);
    const [acknowledgementPageAgreements, setAcknowledgementPageAgreements] = useState<DropdownListDto[]>([]);
    const [workbasketDto, setWorkbasketDto] = useState<WorkbasketTableDto>();

    const onChange = (key: string | string[]) => {
    };
    useEffect(() => {
        const workBasketDataStr = localStorage.getItem("workBasketData");
        const workbasketDto: WorkbasketTableDto = workBasketDataStr !== null ? JSON.parse(workBasketDataStr) : null;
        setWorkbasketDto(workbasketDto)


        setCustomerDto(props.dataDto)
        if (undefined != props.dataDto?.addressList?.length && props.dataDto?.addressList?.length != 0) {
            setAddressList(props.dataDto?.addressList)
        }
        if (undefined != props.dataDto?.bankDetailList?.length && props.dataDto?.bankDetailList?.length != 0) {
            setBankList(props.dataDto?.bankDetailList)
        }
        getCommonDropdownList(props.dataDto?.identificationSource?.id, PageStep.STEP_PERSONNEL_DETAIL)
        getCommonDropdownList(2, PageStep.STEP_ACKNOWLEDGMENT_DETAIL)
    }, [props.dataDto])


    const validateText = (value: string | number | undefined) => {

        return undefined == value || "" == value ? "N/A" : value;
    }
    const getColor = (identificationSourceType: string | undefined) => {
        switch (identificationSourceType) {
            case IDENTIFICATION_SOURCE.NIC: {
                return 'green';
            }
            case IDENTIFICATION_SOURCE.PP: {
                return 'geekblue';
            }
            case IDENTIFICATION_SOURCE.DL: {
                return 'volcano';
            }
            default: {
                return 'gray'
            }
        }
    }


    const toFixed = (value: number | undefined): any => {
        if (undefined != value) {
            let val = value.toString();
            if (val.indexOf(".") != -1) {
                val = val.slice(0, (val.indexOf(".")) + 3);
            }
            val = (+val).toFixed(2);
            return val.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
        return "0.00";
    }

    const getRadioButtonValue = (value: string | undefined): any => {
        if (undefined != value && NOT_AVAILABLE != value) {
            return RADIO_BUTTON_VALUES.YES == value ? "Yes" : "No";
        }
        return "N/A";
    }
    const getCommonDropdownList = (identificationSourceTypeSelection: number | undefined, pageStep: PageStep) => {
        if (identificationSourceTypeSelection) {
            const inputDropdownParameterDtoList: InputDropdownParameterDto =
                {
                    dropdownDataSourceId: COMMON_DROPDOWN.AGREEMENT,
                    findTextValue: "",
                    parameterList: [[identificationSourceTypeSelection], [pageStep], [PARAMETER_LIST.ACTIVE]]
                }


            loadCommonDropdownDataList(inputDropdownParameterDtoList, pageStep);
        }
    }
    const loadCommonDropdownDataList = (dropDownParameterDto: InputDropdownParameterDto, pageStep: PageStep) => {
        customerService.getCommonDropdown(dropDownParameterDto).then(res => {
            if (res.data !== null) {
                if (PageStep.STEP_PERSONNEL_DETAIL === pageStep) {
                    setUserDetailsPageAgreements(res.data.results.activeItemList)
                } else {
                    setAcknowledgementPageAgreements(res.data.results.activeItemList)
                }
            } else {
                message.error(MSG_FAILED_TO_FETCH_COMMON_DROPDOWN_TYPES_ERROR).then();
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
        })
    }

    const items = [
        {
            key: '1',
            label: <>
                <div className='compare-details-header'>
                    <div className="img-div">
                        <img src={step_1_inactive_img}/>
                    </div>
                    <span>
                        Personal Information
                    </span>
                </div>
            </>,
            children: <div>
                <Descriptions size="small" layout="vertical" column={{xxl: 2, xl: 2, lg: 1, md: 1, sm: 1, xs: 1}}
                              labelStyle={{
                                  fontSize: 12,
                                  letterSpacing: 0.25,
                                  // color: 'rgba(0, 0, 0, 0.50)',
                                  marginBottom: 0
                              }} className='description-area'>
                    <Descriptions.Item label="Title">{validateText(customerDto?.titleValue)}</Descriptions.Item>
                    <Descriptions.Item label="Initials">{validateText(customerDto?.initials)}</Descriptions.Item>
                    <Descriptions.Item
                        label="Names Denoted by Initials">{validateText(customerDto?.namesDenotedByInitials)}</Descriptions.Item>
                    <Descriptions.Item label="Surname">{validateText(customerDto?.surname)}</Descriptions.Item>
                    <Descriptions.Item
                        label="Name to Appear on Statement">{validateText(customerDto?.nameToAppearOnStatement)}</Descriptions.Item>
                    <Descriptions.Item label="Gender">{validateText(customerDto?.genderValue)}</Descriptions.Item>
                    <Descriptions.Item
                        label="Date of Birth">{validateText(customerDto?.dateOfBirth)}</Descriptions.Item>
                    <Descriptions.Item
                        label="Natiionality">{validateText(customerDto?.nationalityValue)}</Descriptions.Item>
                    <Descriptions.Item
                        label="Residency Status">{validateText(customerDto?.residencyStatusValue)}</Descriptions.Item>
                    <Descriptions.Item
                        label="Mother`s Maiden Name">{validateText(customerDto?.mothersMaidenName)}</Descriptions.Item>
                    <Descriptions.Item label="Identification Type"><Tag
                        color={getColor(customerDto?.identificationSource?.sourceType)}>{validateText(customerDto?.identificationSource?.sourceType)}</Tag></Descriptions.Item>
                    <Descriptions.Item
                        label="NIC">{validateText(customerDto?.nicNo)}</Descriptions.Item>
                    {IDENTIFICATION_SOURCE.NIC != customerDto?.identificationSource?.sourceType ?
                        <>
                            <Descriptions.Item
                                label="Identification Value">{validateText(customerDto?.identificationSource?.identificationValue)}</Descriptions.Item>
                            <Descriptions.Item
                                label="Expire Date">{validateText(customerDto?.ppOrDlExpiryDate)}</Descriptions.Item>
                        </>
                        : <></>}
                </Descriptions>
                <Checkbox.Group className='personal-info-checked-box checked-disabled-checkboxes'
                                defaultValue={customerDto?.pageWiseAgreementIdList} onChange={onChange}>
                    {userDetailsPageAgreements.map((agreement: DropdownListDto) => (
                        <Checkbox disabled value={agreement.value}>{agreement.label}</Checkbox>
                    ))}
                </Checkbox.Group>
            </div>,
        },
        {
            key: '2',
            label: <>
                <div className='compare-details-header'>
                    <div className="img-div">
                        <img src={step_2_inactive_img}/>
                    </div>
                    <span>
                        Residential Information
                    </span>
                </div>
            </>,
            children: <div>
                <Row gutter={[16, 16]}>
                    {addressList?.map((address: AddressDto, index: number) => {
                        const hasCorrespondenceAddress = addressList?.some((address: AddressDto) => address.type === "CORRESPONDENCE");
                        return (<Col span={24} className='residential-col'>
                            <Card className='two_column_card '
                                  title={"PRIMARY" === address.type ? "Permanent Address" : "Correspondence Address"}
                                  size='small'>
                                <Descriptions size="small" layout="vertical"
                                              column={{xxl: 2, xl: 2, lg: 1, md: 1, sm: 1, xs: 1}}
                                              labelStyle={{
                                                  fontSize: 12,
                                                  letterSpacing: 0.25,
                                                  // color: 'rgba(0, 0, 0, 0.50)',
                                                  marginBottom: 0
                                              }}
                                              className='description-area'>
                                    <Descriptions.Item
                                        label="Address Line 1 ">{validateText(address?.line1)}</Descriptions.Item>
                                    <Descriptions.Item
                                        label="Address Line 2">{validateText(address?.line2)}</Descriptions.Item>
                                </Descriptions>
                                <Descriptions size="small" layout="vertical"
                                              column={{xxl: 4, xl: 2, lg: 1, md: 1, sm: 1, xs: 1}}
                                              labelStyle={{
                                                  fontSize: 12,
                                                  letterSpacing: 0.25,
                                                  // color: 'rgba(0, 0, 0, 0.50)',
                                                  marginBottom: 0
                                              }}
                                              className='description-area'>

                                    <Descriptions.Item
                                        label="Town">{validateText(address?.townOrCity)}</Descriptions.Item>
                                    <Descriptions.Item
                                        label="District">{validateText(CommonFunction.getDistrictLabelFromValue(address?.district))}</Descriptions.Item>
                                    <Descriptions.Item
                                        label="Zip Code">{validateText(address?.postalCode)}</Descriptions.Item>
                                    <Descriptions.Item
                                        label="Country">{validateText(address?.countryName)}
                                    </Descriptions.Item>

                                </Descriptions>
                                <Descriptions size="small" layout="vertical"
                                              column={{xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1}}
                                              labelStyle={{
                                                  fontSize: 12,
                                                  letterSpacing: 0.25,
                                                  // color: 'rgba(0, 0, 0, 0.50)',
                                                  marginBottom: 0
                                              }}
                                              className='description-area'>
                                    {"PRIMARY" === address?.type ? <>

                                        {IDENTIFICATION_SOURCE.PP != customerDto?.identificationSource?.sourceType ?
                                            <Descriptions.Item
                                                label="Is the Permanent Address identical to the address on the NIC/Driver's License">{address?.permanentAddressIdenticalToNicDl ? "Yes" : "No"}</Descriptions.Item> : <></>}
                                        <Descriptions.Item
                                            label="Is the Correspondence Address the same as Permanent Address">{!hasCorrespondenceAddress ? "Yes" : "No"}</Descriptions.Item>
                                    </> : <></>}
                                </Descriptions>
                            </Card>
                        </Col>)
                    })}
                    <Col span={24}>
                        <Card className='two_column_card contact_two_column_card' title='Contact Details' size='small'>
                            <Descriptions size="small" layout="vertical"
                                          column={{xxl: 4, xl: 2, lg: 1, md: 1, sm: 1, xs: 1}}
                                          labelStyle={{
                                              fontSize: 12,
                                              letterSpacing: 0.25,
                                              // color: 'rgba(0, 0, 0, 0.50)',
                                              marginBottom: 0
                                          }}
                                          className='description-area'>
                                <Descriptions.Item
                                    label="Mobile Number">{validateText(customerDto?.mobileNo)}</Descriptions.Item>
                                <Descriptions.Item
                                    label="Fax">{validateText(customerDto?.faxNo)}</Descriptions.Item>
                                <Descriptions.Item
                                    label="Office Phone Number">{validateText(customerDto?.officePhoneNo)}</Descriptions.Item>
                                <Descriptions.Item
                                    label="Residential Phone Number">{validateText(customerDto?.homePhoneNo)}</Descriptions.Item>
                            </Descriptions>
                            <Descriptions size="small" layout="vertical"
                                          column={{xxl: 2, xl: 1, lg: 1, md: 1, sm: 1, xs: 1}}
                                          labelStyle={{
                                              fontSize: 12,
                                              letterSpacing: 0.25,
                                              // color: 'rgba(0, 0, 0, 0.50)',
                                              marginBottom: 0
                                          }}
                                          className='description-area'>
                                <Descriptions.Item
                                    label="Email">{validateText(customerDto?.email)}</Descriptions.Item>
                                {/*<Descriptions.Item*/}
                                {/*    label="Confirmations & Statements Will Be Sent Via,">{validateText(customerDto?.mailingMethod)}</Descriptions.Item>*/}
                            </Descriptions>
                        </Card>
                    </Col>
                </Row>
            </div>,
        },
        {
            key: '3',
            label: <>
                <div className='compare-details-header'>
                    <div className="img-div">
                        <img src={step_3_inactive_img}/>
                    </div>
                    <span>
                        Investment Information
                    </span>
                </div>
            </>,
            children: <div>
                <Descriptions size="small" layout="vertical"
                              column={{xxl: 2, xl: 2, lg: 1, md: 1, sm: 1, xs: 1}}
                              labelStyle={{
                                  fontSize: 12,
                                  letterSpacing: 0.25,
                                  // color: 'rgba(0, 0, 0, 0.50)',
                                  marginBottom: 0
                              }}
                              className='description-area'>
                    <Descriptions.Item
                        label="Investment Objective">{validateText(customerDto?.incomeDetail?.investmentObjectiveValue)}</Descriptions.Item>
                    {OTHER == validateText(customerDto?.incomeDetail?.investmentObjectiveValue) ?
                        <>
                            <Descriptions.Item
                                label="Other Investment Objective">{validateText(customerDto?.incomeDetail?.otherInvestmentObjective)}</Descriptions.Item>
                            <Descriptions.Item
                                label="Initial Investment Amount (LKR)">{toFixed(customerDto?.incomeDetail?.initialInvestmentAmount)}</Descriptions.Item>
                        </>
                        :
                        <Descriptions.Item
                            label="Initial Investment Amount (LKR)">{toFixed(customerDto?.incomeDetail?.initialInvestmentAmount)}</Descriptions.Item>
                    }

                    <Descriptions.Item
                        label="Expected Future Investment Amount (LKR)">{toFixed(customerDto?.incomeDetail?.expectedFutureInvestmentAmount)}</Descriptions.Item>
                    <Descriptions.Item
                        label="Source of Wealth">{validateText(customerDto?.incomeDetail?.sourceOfWealthValue)}</Descriptions.Item>
                    {OTHER == validateText(customerDto?.incomeDetail?.sourceOfWealthValue) ?
                        <>
                            <Descriptions.Item
                                label="Other Source of Funds">{validateText(customerDto?.incomeDetail?.otherSourceOfWealth)}</Descriptions.Item>
                            <Descriptions.Item
                                label="Annual Income">{validateText(customerDto?.incomeDetail?.annualIncomeRange)}</Descriptions.Item>
                        </>
                        :
                        <Descriptions.Item
                            label="Annual Income">{validateText(customerDto?.incomeDetail?.annualIncomeRange)}</Descriptions.Item>
                    }

                    <Descriptions.Item
                        label="Occupation/ Position Held">{validateText(customerDto?.incomeDetail?.occupation)}</Descriptions.Item>
                    <Descriptions.Item
                        label="Name of the Employer">{validateText(customerDto?.incomeDetail?.nameOfEmployer)}</Descriptions.Item>
                    <Descriptions.Item
                        label="Nature of Business">{validateText(customerDto?.incomeDetail?.natureOfBusiness)}</Descriptions.Item>
                    <Descriptions.Item
                        label="Address of Employer/ Businesses">{validateText(customerDto?.incomeDetail?.addressOfEmployer)}</Descriptions.Item>
                    <Descriptions.Item
                        label="Taxpayer Identification Number (TIN)">{validateText(customerDto?.incomeDetail?.tinNo)}</Descriptions.Item>

                </Descriptions>
            </div>,
        },
        {
            key: '4',
            label: <>
                <div className='compare-details-header'>
                    <div className="img-div">
                        <img src={step_4_inactive_img}/>
                    </div>
                    <span>
                        Bank Information
                    </span>
                </div>
            </>,
            children:
                <div>
                    <Row gutter={[16, 16]}>
                        {bankList?.map((bank: BankDetailDto, index: number) => {
                            return (<Col span={24}>
                                <Card className='two_column_card'
                                      title={"PRIMARY" === bank.bankAccountType ? "Primary Bank Account Details" : "Secondary Bank Account Details"}
                                      size='small'>
                                    <Descriptions size="small" layout="vertical"
                                                  column={{xxl: 2, xl: 2, lg: 1, md: 1, sm: 1, xs: 1}}
                                                  labelStyle={{
                                                      fontSize: 12,
                                                      letterSpacing: 0.25,
                                                      // color: 'rgba(0, 0, 0, 0.50)',
                                                      marginBottom: 0
                                                  }}
                                                  className='description-area'>
                                        <Descriptions.Item
                                            label="Name of the Bank ">{validateText(bank?.bankName)}</Descriptions.Item>
                                        <Descriptions.Item
                                            label="Branch">{validateText(bank?.branchName)}</Descriptions.Item>
                                        <Descriptions.Item
                                            label="Account Number">{validateText(bank?.accountNo)}</Descriptions.Item>
                                        <Descriptions.Item
                                            label="Account Holder`s Name">{validateText(bank?.accountHolderName)}</Descriptions.Item>
                                    </Descriptions>
                                </Card>
                            </Col>)
                        })}
                    </Row>
                </div>,
        },
        {
            key: '5',
            label: <>
                <div className='compare-details-header'>
                    <div className="img-div">
                        <img src={step_5_inactive_img}/>
                    </div>
                    <span>
                        Other Information
                    </span>
                </div>
            </>,
            children: <div>
                <Descriptions size="small" layout="vertical"
                              column={{xxl: 2, xl: 2, lg: 1, md: 1, sm: 1, xs: 1}}
                              labelStyle={{
                                  fontSize: 12,
                                  letterSpacing: 0.25,
                                  // color: 'rgba(0, 0, 0, 0.50)',
                                  marginBottom: 0
                              }}
                              className='description-area'>
                    <Descriptions.Item
                        label="U.S Permanent Resident">{getRadioButtonValue(customerDto?.greenCardHolderStatus)}</Descriptions.Item>
                    <Descriptions.Item
                        label="Politically Exposed Status">{getRadioButtonValue(customerDto?.politicallyExposedStatus)}</Descriptions.Item>
                </Descriptions>
            </div>,
        },
        {
            key: '6',
            label: <>
                <div className='compare-details-header'>
                    <div className="img-div">
                        <img src={step_6_inactive_img}/>
                    </div>
                    <span>
                        Attachments and Supporting Information
                    </span>
                </div>
            </>,
            children: <div>
                <Descriptions size="small" layout="vertical"
                              column={{xxl: 2, xl: 1, lg: 1, md: 1, sm: 1, xs: 1}}
                              labelStyle={{
                                  fontSize: 12,
                                  letterSpacing: 0.25,
                                  // color: 'rgba(0, 0, 0, 0.50)',
                                  marginBottom: 0
                              }}
                              className='description-area'>
                    <Descriptions.Item
                        label="Is the Billing Proof Under Customer Name">{getRadioButtonValue(customerDto?.isBillingProofUnderYourName)}</Descriptions.Item>
                    <Descriptions.Item
                        label="Billing Proof Type">{RADIO_BUTTON_VALUES.UTILITY_BILL == customerDto?.billingProofType ? "Utility Bill" : RADIO_BUTTON_VALUES.BANK_STATEMENT == customerDto?.billingProofType ? "Bank Statement" : "N/A"}</Descriptions.Item>
                </Descriptions>
            </div>,
        },
        {
            key: '7',
            label: <>
                <div className='compare-details-header'>
                    <div className="img-div">
                        <img src={step_7_inactive_img}/>
                    </div>
                    <span>
                        Acknowledgement Information
                    </span>
                </div>
            </>,
            children:
                <div className='checked-disabled-checkboxes'>
                    <Descriptions size="small" column={{xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1}}>
                        <Descriptions.Item label="">
                            <Checkbox.Group defaultValue={customerDto?.pageWiseAgreementIdList} onChange={onChange}>
                                {acknowledgementPageAgreements.map((agreement: DropdownListDto) => (
                                    <Checkbox disabled value={agreement.value}>{agreement.label}</Checkbox>
                                ))}
                            </Checkbox.Group>
                            {customerDto?.originallySeen && (
                                <Checkbox defaultChecked disabled >
                                    Originally Seen by RM
                                </Checkbox>
                            )}
                        </Descriptions.Item>
                    </Descriptions>
                </div>,
        },
        {
            key: '8',
            label: <>
                <div className='compare-details-header'>
                    <div className="img-div">
                        <img src={reject_user}/>
                    </div>
                    <span>
                        Reject Reason
                    </span>
                </div>
            </>,
            children: (
                <div>
                    {null != workbasketDto?.detailRejectReason ? <Col span={24}>
                        <Card className='two_column_card'
                              title='Detail & Document Verification Reject Reason' size='small'>
                            <Descriptions size="small" layout="vertical"
                                          column={{xxl: 4, xl: 2, lg: 1, md: 1, sm: 1, xs: 1}}
                                          labelStyle={{
                                              fontSize: 12,
                                              letterSpacing: 0.25,
                                              // color: 'rgba(0, 0, 0, 0.50)',
                                              marginBottom: 0
                                          }}
                                          className='description-area'>
                                <Descriptions.Item
                                    label="">{validateText(workbasketDto?.detailRejectReason)}</Descriptions.Item>
                            </Descriptions>
                        </Card>
                    </Col> : <></>}

                    {null != workbasketDto?.videoRejectReason ? <Col span={24}>
                        <Card
                            className={null == workbasketDto?.videoRejectReason ? 'two_column_card' : 'two_column_card contact_two_column_card'}
                            title='Video Verification Reject Reason' size='small'>
                            <Descriptions size="small" layout="vertical"
                                          column={{xxl: 4, xl: 2, lg: 1, md: 1, sm: 1, xs: 1}}
                                          labelStyle={{
                                              fontSize: 12,
                                              letterSpacing: 0.25,
                                              // color: 'rgba(0, 0, 0, 0.50)',
                                              marginBottom: 0
                                          }}
                                          className='description-area'>
                                <Descriptions.Item
                                    label="">{validateText(workbasketDto?.videoRejectReason)}</Descriptions.Item>
                            </Descriptions>
                        </Card>
                    </Col> : <></>}
                </div>
            )
        },
        {
            key: '9',
            label: <>
                <div className='compare-details-header'>
                    <div className="img-div">
                        <img src={remark}/>
                    </div>
                    <span>
                        Internal Remark
                    </span>
                </div>
            </>,
            children: (
                <div>
                    {null != workbasketDto?.detailInternalRemark ? <Col span={24}>
                        <Card className='two_column_card'
                              title='Detail & Document Verification Internal Remark' size='small'>
                            <Descriptions size="small" layout="vertical"
                                          column={{xxl: 4, xl: 2, lg: 1, md: 1, sm: 1, xs: 1}}
                                          labelStyle={{
                                              fontSize: 12,
                                              letterSpacing: 0.25,
                                              // color: 'rgba(0, 0, 0, 0.50)',
                                              marginBottom: 0
                                          }}
                                          className='description-area'>
                                <Descriptions.Item
                                    label="">{validateText(workbasketDto?.detailInternalRemark)}</Descriptions.Item>
                            </Descriptions>
                        </Card>
                    </Col> : <></>}

                    {null != workbasketDto?.videoInternalRemark ? <Col span={24}>
                        <Card
                            className={null == workbasketDto?.videoInternalRemark ? 'two_column_card' : 'two_column_card contact_two_column_card'}
                            title='Video Verification Internal Remark' size='small'>
                            <Descriptions size="small" layout="vertical"
                                          column={{xxl: 4, xl: 2, lg: 1, md: 1, sm: 1, xs: 1}}
                                          labelStyle={{
                                              fontSize: 12,
                                              letterSpacing: 0.25,
                                              // color: 'rgba(0, 0, 0, 0.50)',
                                              marginBottom: 0
                                          }}
                                          className='description-area'>
                                <Descriptions.Item
                                    label="">{validateText(workbasketDto?.videoInternalRemark)}</Descriptions.Item>
                            </Descriptions>
                        </Card>
                    </Col> : <></>}
                </div>
            )
        },
    ];

    let filteredItems;
    filteredItems = (null === workbasketDto?.detailRejectReason || '' === workbasketDto?.detailRejectReason)
    && (null === workbasketDto?.videoRejectReason || '' === workbasketDto?.videoRejectReason) ? items.filter(item => item.key !== '8') : items;

    filteredItems = (null === workbasketDto?.detailInternalRemark || '' === workbasketDto?.detailInternalRemark)
    && (null === workbasketDto?.videoInternalRemark || '' === workbasketDto?.videoInternalRemark) ? filteredItems.filter(item => item.key !== '9') : filteredItems;

    return (
        <>
            {customerDto && (
                <Collapse
                    defaultActiveKey={['0']}
                    onChange={onChange}
                    expandIconPosition={expandIconPosition}
                    items={filteredItems}
                />
            )}
        </>
    );
};

export default LeftSideDetailsCollapse;
